var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.87498 10.1249C2.92498 8.1749 2.92498 5.0999 4.87498 3.1499L13.2 11.4749L15.975 14.2499L20.25 18.5249C21 19.2749 21 20.3999 20.25 21.1499C19.5 21.8999 18.15 21.8999 17.475 20.9999L14.4 17.1749C13.65 16.1999 12.3 15.8999 11.1 16.3499L4.87498 10.1249Z",
    stroke: "#9CA3AF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.975 9.0749L20.025 5.0249",
    stroke: "#9CA3AF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.325 12.6C14.625 12.525 14.85 12.525 15.15 12.45C16.125 12.375 17.25 11.85 18.375 10.725L22.05 7.05005",
    stroke: "#9CA3AF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.22497 14.4751L3.97497 18.7501C3.14997 19.3501 3.07497 20.5501 3.82497 21.2251C4.57497 21.9751 5.69997 21.8251 6.29997 21.0751L10.575 15.7501",
    stroke: "#9CA3AF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 3L14.25 6.675C13.125 7.8 12.525 8.925 12.525 9.9C12.525 10.2 12.45 10.425 12.375 10.725",
    stroke: "#9CA3AF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeals);
export default __webpack_public_path__ + "static/media/meals.14f7c88c712ab870ea443f22bb70763f.svg";
export { ForwardRef as ReactComponent };